"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.wrap = wrap;
/* eslint-disable import/prefer-default-export */

function wrap(n, min, max) {
  var d = max - min;
  return n === max ? n : ((n - min) % d + d) % d + min;
}


//////////////////
// WEBPACK FOOTER
// ./~/frontend_core/~/google-map-react/lib/utils/lib_geo/wrap.js
// module id = 840
// module chunks = 0